import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import ChatList from './ChatList';
import ChatForm from './ChatForm';
import { variants } from '../../../variants/variants';
import { useDispatch } from 'react-redux';
import { setChatStatus } from '../../Auth/authSlice';
import { green } from '@mui/material/colors';
import { useTheme } from '@emotion/react';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../context/Ability';

const Chats = () => {
  const [editingChat, setEditingChat] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const dispatch = useDispatch();
  const [inputHeight, setInputHeight] = useState(100);
  const theme = useTheme();
  const inputRef = useRef();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [showToolbar, setShowToolbar] = useState(false);
  const ability = useAbility(AbilityContext);
  const [disabled, setDisabled] = useState(true); // State to manage the disabled state
  useLayoutEffect(() => {
    if (ability.can('create', 'Chats')) {
      setDisabled(false);
    }
  }, [ability]);
  useLayoutEffect(() => {
    dispatch(setChatStatus(false));
  }, [dispatch]);
  const handleChange = (val) => {
    setInputHeight(val);
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      if (inputRef.current) {
        setInputHeight(inputRef.current.clientHeight);
      }
    };

    const handleFocus = () => {
      setKeyboardVisible(true);
      adjustBottomPosition();
    };

    const handleBlur = () => {
      setKeyboardVisible(false);
      adjustBottomPosition();
    };

    const adjustBottomPosition = () => {
      if (inputRef.current) {
        const bottomOffset = keyboardVisible && !showToolbar ? '80px' : '0px';
        inputRef.current.style.bottom = bottomOffset;
      }
    };

    window.addEventListener('resize', handleResize);

    // Event listeners for focus and blur on the form control
    if (inputRef.current) {
      const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
      formInputs.forEach((input) => {
        input.addEventListener('focus', handleFocus);
        input.addEventListener('blur', handleBlur);
      });
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      if (inputRef.current) {
        const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
        formInputs.forEach((input) => {
          input.removeEventListener('focus', handleFocus);
          input.removeEventListener('blur', handleBlur);
        });
      }
    };
  }, [keyboardVisible]);

  useLayoutEffect(() => {
    if (inputRef.current) {
      const bottomOffset = '0px';
      inputRef.current.style.bottom = bottomOffset;
      setInputHeight(inputRef.current.clientHeight);
    }
  }, [showToolbar]);
  return (
    <Grid
      container
      sx={{
        backgroundColor: isSm ? '' : '#EEF5FF',
        padding: isSm ? 0 : 1,
        height: isSm ? '100%' : isMd ? 'calc(100vh - 150px)' : 'calc(100vh - 80px)',
        display: 'flex',
        flex: 1,
        overflow: 'scroll',
        borderRadius: variants.boxRadius.NAVBAR,
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Grid
        container
        sx={{
          position: 'relative',
          borderRadius: variants.boxRadius.NAVBAR,
          background: 'white',
          border: isSm ? 0 : 1,
          borderColor: 'divider',
          height: '100%',
          display: 'flex',
          flex: 1,
        }}
      >
        {/* <Grid item xs={12} sx={{ overflow: 'auto', paddingBottom: '0', maxHeight: '79vh', height:'100%', background: }}> */}
        <Grid
          item
          xs={12}
          sx={{
            overflow: 'scroll',
            paddingBottom: '0',
            position: 'relative',
            height:isSm?'90%': `calc(90vh - ${inputHeight}px)`,
          }}
        >
          {/* <Box sx={{ left: 0, top: 0, bottom: 0, right: 0, paddingBottom: '100px' }}> */}
          <ChatList
            setEditingChat={setEditingChat}
            showScrollButton={showScrollButton}
            setShowScrollButton={setShowScrollButton}
            inputHeight={inputHeight}
            disabled={disabled}
            setDisabled={setDisabled}
          />
          {/* </Box> */}
        </Grid>
        <Grid item xs={12} sx={!isSm&&{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
          <ChatForm
            editingChat={editingChat}
            setEditingChat={setEditingChat}
            showScrollButton={showScrollButton}
            onChange={handleChange}
            inputRef={inputRef}
            showToolbar={showToolbar}
            setShowToolbar={setShowToolbar}
            disabled={disabled}
            setDisabled={setDisabled}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Chats;
